export default idType =>
  ['national_id', 'foreign_residence_id'].includes(idType);
